import React from 'react';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import BaseSubnav, { SubnavGroup } from './BaseSubnav';
import { getPublicPath } from 'utils/paths';

const NewTopbarFreelanceSubnav: React.FC = () => {
  const { t } = useI18n('topbar');
  const { locale } = useRouter();

  const illustration = getPublicPath('/images/topbar/freelance-circle.svg');

  const groups: SubnavGroup[] = [
    {
      title: t('freelance_subnav.offer.title'), // "Para contratar"
      items: [
        {
          text: t('nav.companies'), // "Empresas"
          href: getAppUrl(APP_URLS.freelanceCompanies, locale)
        },
        {
          text: t('freelance_subnav.talent.title'), // "Talento freelance"
          href: getAppUrl(APP_URLS.freelanceTalent, locale)
        }
      ]
    },
    {
      title: t('freelance_subnav.guides.title'), // "Guías"
      items: [
        {
          text: t('freelance_subnav.guides.companies_guide'),
          href: `${getAppUrl(APP_URLS.blog, locale)}${
            locale === 'en'
              ? '/guide-how-to-work-with-freelance-in-tech'
              : '/guia-como-trabajar-con-freelance-en-tech-manfred'
          }`
        },
        {
          text: t('freelance_subnav.guides.talent_guide'),
          href: `${getAppUrl(APP_URLS.blog, locale)}${
            locale === 'en'
              ? '/guide-for-freelance-newbies-in-tech'
              : '/guia-para-freelance-novatos-en-tech-manfred'
          }`
        }
      ]
    }
  ];

  return (
    <BaseSubnav
      illustration={illustration}
      title={t('freelance_subnav.title')}
      description={t('freelance_subnav.desc')}
      groups={groups}
    />
  );
};

export default NewTopbarFreelanceSubnav;
